import GPlacesHelper from 'helpers/GPlacesHelper';
// import InfowindowPOIBasemap from '../views/infowindow/infowindowPOIBasemap/InfowindowPOIBasemap';
// import DistanceMatrixService from '../services/DistanceMatrixService';
import Utils from 'helpers/Utils';
import BaseLayer from '../../lmm-widget/src/layers/types/_base/BaseLayer';

export default BaseLayer.extend({

    initialize() {
        this.widget.selectedPOI = null;
        this.selectedPOI = null;
        // this.distanceMatrixService = new DistanceMatrixService();
        // this.selectedPOIIW = new InfowindowPOIBasemap({
        //   widget: this.widget
        // });
        this.listenTo(this.widget.bus, 'CLOSED_POIMAPBASE_IW', () => {
            this.removeMarker();
        });
        this.listenTo(this.widget.bus, 'CLICK_ON_MARKER', () => {
            this.unSelectPOI();
        });

        this.listenTo(this.widget.bus, 'POIBASE_SELECTED', (marker = {}) => {
            this.getDataPlaceFromSearch(marker);
        });

        this.listenTo(this.widget.bus, 'CREATE_POINT_REFERENCE', (configPRef) => {
            let markerConfig = configPRef;
            if (!(configPRef &&
                configPRef.properties &&
                configPRef.properties.hotel &&
                configPRef.properties.hotel.code)) {
                    markerConfig.map = this.widget.map;
                }
            markerConfig.clickable = false;
            const icon = {
                url: Utils.getImgUrl(this.widget.config.genericIconMarker, this.widget),
                size: new google.maps.Size(50, 50),
                scaledSize: new google.maps.Size(40, 40)
            };
            markerConfig.icon = icon;
            this._removeAutocompleteMarker();
            this.pointReference = new google.maps.Marker(markerConfig);
        });

        this.listenTo(this.widget.bus, 'RESET_AUTOCOMPLETE', () => {
            this._removeAutocompleteMarker();
        });

        this.listenTo(this.widget.bus, 'DELETE_POINT_REFERENCE', () => {
            this._removeAutocompleteMarker();
        });

        // this._addEventListener();
    },

    _removeAutocompleteMarker() {
        if (this.pointReference) {
            this.pointReference.setMap(null);
            this.pointReference = null;
        }
    },

    _addEventListener() {
        this.widget.map.addListener('click', (event) => {
            this.unSelectPOI();
            event.stop();

            if (this.widget.clickAlternativeHotels === true &&
                (navigator.userAgent.toLowerCase().indexOf('android') > -1 || this.widget.isMobile)) {
                this.widget.clickAlternativeHotels = false;
                return;
            }

            if (typeof this.widget.componentsStatus === 'undefined' ||
                (this.widget.componentsStatus.directionHide && this.widget.componentsStatus.routeDetailsPanel)
            ) {
                if (typeof this.widget.isTravelTimeActivated !== 'undefined' && this.widget.isTravelTimeActivated ===
                    true) {
                    this.addTraveltimeToInfowindow(event);
                } else {
                    this.createBaseInfowindow(event);
                }
            } else if (!this.widget.componentsStatus.directionHide) {
                this.widget.bus.trigger(
                    'CLICK_ON_MAP_ROUTE',
                    Object.assign({}, event)
                );
            }
        });
    },

    _addClickListener(marker) {
        marker.clickListener = google.maps.event.addListener(marker, 'click', (event) => {
            if (event instanceof Event) {
                event.stopPropagation();
            }
            this.widget.bus.trigger('CLICK_ON_MAIN_HOTEL_MARKER');
        });
    },

    add() {},

    remove() {},

    // TODO change param name
    addMarker(object, customIcon) {
        let position;
        if (object.position instanceof google.maps.LatLng) {
            position = object.position;
        } else {
            position = new google.maps.LatLng(object.position);
        }
        var marker = new google.maps.Marker({
            position: position,
            map: this.widget.map,
            // properties: place,
            icon: customIcon,
            zIndex: 0
        });
        this._addClickListener(marker);
        return marker;
    },

    createBaseInfowindow(event) {
        if (event.placeId) {
            this.getDataPlace(event);
        } else {
            this.unSelectPOI();
            //Informs that others infowindows should be removed.
            this.widget.bus.trigger('CLICK_ON_MAP');
        }
    },

    addTraveltimeToInfowindow(event) {
        this.distanceMatrixService.calculateDistance({
            origin: this.widget.mainHotel.position,
            destinations: [{ position: event.latLng }],
            travelMode: this.widget.travelModeComponent.toUpperCase()
        }).then((results) => {
            this.widget.selectedPOIDistanceMatrix = results[0];
            if (this.selectedPOIIW.infowindow.isOpen()) {
                this.selectedPOIIW.addTravelTimeInfo();
            } else {
                this.createBaseInfowindow(event);
            }
        });
    },

    getDataPlaceFromSearch(event) {
        this.unSelectPOI();
        let prop = (event.placeId === undefined) ? 'place_id' : 'placeId';
        let avoidedConfigCat = this.widget.config.avoidedCategoriesOnMap;
        let ignore = [];
        GPlacesHelper.getDetails(this.widget.map, event[prop])
            .done((place) => {
                if (avoidedConfigCat) {
                    ignore = place[0].types.filter(val => avoidedConfigCat.indexOf(val) !== -1);
                }
                if (!ignore.length) {
                    if (typeof this.widget.isTravelTimeActivated !== 'undefined' &&
                        this.widget.isTravelTimeActivated) {
                        this.distanceMatrixService.calculateDistance({
                            origin: this.widget.mainHotel.position,
                            destinations: [{ position: place[0].geometry.location }],
                            travelMode: this.widget.travelModeComponent.toUpperCase()
                        }).then((results) => {
                            this.widget.selectedPOIDistanceMatrix = results[0];
                            this.selectPOI(place[0], event.customIcon);
                        });
                    } else {
                        this.selectPOI(place[0], event.customIcon);
                    }
                }
            }).fail(() => {
                console.log('fail');
            });
    },

    getDataPlace(event) {
        let prop = (event.placeId === undefined) ? 'place_id' : 'placeId';
        let avoidedConfigCat = this.widget.config.avoidedCategoriesOnMap;
        let ignore = [];
        GPlacesHelper.getDetails(this.widget.map, event[prop])
            .done((place) => {
                if (avoidedConfigCat) {
                    ignore = place[0].types.filter(val => avoidedConfigCat.indexOf(val) !== -1);
                }
                if (!ignore.length) {
                    this.selectPOI(place[0], event.customIcon);
                }
            }).fail(() => {
                console.log('fail');
            });
    },

    selectPOI(place, customIcon) {
        this.unSelectPOI();
        let position = place.geometry.location;
        this.selectedPOI = new google.maps.Marker({
            position: new google.maps.LatLng(position.lat(), position.lng()),
            map: this.widget.map,
            properties: place,
            icon: customIcon,
            zIndex: 999
        });

        this.selectedPOI.setMap(this.widget.map);
        this.widget.selectedPOI = this.selectedPOI;
        // this.selectedPOIIW.openInfowindow(this.widget.selectedPOI);
        // this.widget.infowindowCategoryPOI = this.selectedPOIIW;
        //Informs that others infowindows should be removed.
        this.widget.bus.trigger('CLICK_ON_POIBASEMAP');
        this.setSuggestedLocationsInLocalStorage(place);
    },

    removeMarker() {
        if (this.widget.selectedPOI !== null && this.selectedPOI !== null) {
            this.widget.selectedPOI.setMap(null);
            this.widget.selectedPOI = null;
            this.selectedPOI = null;
        }
        this.widget.selectedPOI = null;
    },

    unSelectPOI() {
        if (this.selectedPOI !== null) {
            this.removeMarker();
            // this.selectedPOIIW.closeInfowindow();
        }
    },

    getSelectedPoi() {
        return this.widget.selectedPOI;
    },

    getSelectedPoiIW() {
        return this.selectedPOIIW;
    },

    setSuggestedLocationsInLocalStorage(element) {
        if (typeof(Storage) !== 'undefined' && typeof element !== 'undefined') {
            const suggestedLocations = !localStorage.getItem('suggestedLocations') ? [] :
                JSON.parse(localStorage.getItem('suggestedLocations'));

            for (let i = 0; i < suggestedLocations.length; i++) {
                if (suggestedLocations[i].name === element.name) {
                    suggestedLocations.splice(i, 1);
                    suggestedLocations.unshift(element);
                    localStorage.setItem('suggestedLocations', JSON.stringify(suggestedLocations));
                    return;
                }
            }

            if (suggestedLocations.length >= this.widget.maxNumbersOfSuggestedPlaces) {
                suggestedLocations.pop();
            }
            suggestedLocations.unshift(element);

            localStorage.setItem('suggestedLocations', JSON.stringify(suggestedLocations));
        }
    }

});



// WEBPACK FOOTER //
// ./src/layers/BaseMapLayer.js